import React, {useEffect, useRef, useState} from 'react';
import styles from "./Headers.module.scss";
import commonStyle from "../../config/Common.module.scss";
import StyledTable from "../table/StyledTable";
import {HeaderDataFetcher} from "../../datafetcher/HeaderDataFetcher";
import {useHistory} from "react-router";
import {viewResetAction} from "../../redux/features/view/viewSlice";
import {useAppDispatch} from "../../redux/hook";
import {useParams} from "react-router-dom";
import {InputModel} from "../../model/InputModel";
import {useOrganization} from "../../hook/useOrganization";
import HttpClient from "../../datafetcher/HttpClient";
import {nanoid} from "nanoid";
import InputDialog from "../dialog/InputDialog";
import IconLinkButton from "../button/IconLinkButton";
import ReverseSolidLinkSmallButton from '../button/ReverseSolidLinkSmallButton';
import OutlinedIcon from "../icon/OutlinedIcon";
import PageSummary from "../pagesummary/PageSummary";
import {CurrentISODate} from "../../util/DateUtil";
import {jcr} from "../../datafetcher/JCRDataFetcher";

export default function Headers() {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const query = new URLSearchParams(history.location.search);
    const params:any = useParams<{hid: string}>();
    const [newOpen, setNewOpen] = useState(false);
    const [updateData, setUpdateData] = useState<any>({});
    const [headerId, setHeaderId] = useState("");
    const [formKey , setFormKey] = useState("");
    const [deleteList,setDeleteList] = useState<string[]>([]);
    const [dataFetcher, setDataFetcher] = useState<HeaderDataFetcher|null>(null);
    const  orgCmdProp = useOrganization();
    const apiName = "header"
    const apiNames = "headers"
    const inputFile = useRef<HTMLInputElement>(null);

    const handleCloseNewDialog = () => {
        setNewOpen(false);
    }

    const handleOpenNewDialog = () => {
        setNewOpen(true);
    }

    const handleUploadDialog = () => {
        if(inputFile !== null && inputFile.current !== null) {
            inputFile.current.click();
        }
    }

    const doUploadFile = () => {
        if(inputFile && inputFile.current) {
            if(inputFile.current.files) {
                jcr.header.upload(inputFile.current.files).then((response) => {
                    if(!(orgCmdProp && orgCmdProp.currentOrg !== null && orgCmdProp.orgDetail !== null)) return;
                    setDataFetcher(new HeaderDataFetcher(orgCmdProp.currentOrg,() => {
                            dispatch(viewResetAction());
                        }
                    ));
                    setFormKey(nanoid());
                })
            }
        }
    }

    const handleUpdateDialog = (values: InputModel[]) => {
        let data: any = updateData;
        values.forEach(object => {
            data[object.id] = object.defaultValue;
        })
        data['createdAt'] = updateData.createdAt;
        data['modifiedAt'] = new Date().getTime();

        HttpClient.post("/api/v0/jcr/org/" + orgCmdProp?.currentOrg!.orgCode + "/lite/" + apiNames , data).then((response) => {
            history.push({
                pathname: "/headers",
                search: history.location.search
            });
            setUpdateData({})
            setHeaderId("");
            setNewOpen(false);
            setFormKey(nanoid());


        }).catch((e) => {
            console.log(e);
        })
    }

    const handleSaveDialog = (values: InputModel[]) => {
        let data: any = {};
        values.forEach(object => {
            data[object.id] = object.defaultValue;
        })
        data['createdAt'] = new Date().getTime();
        data['modifiedAt'] = new Date().getTime();

        HttpClient.post("/api/v0/jcr/org/" + orgCmdProp?.currentOrg!.orgCode + "/lite/" + apiNames , data).then((response) => {
            setHeaderId("");
            setUpdateData({});
            setNewOpen(false);
            setFormKey(nanoid());

            history.push({
                pathname: history.location.pathname + "/" + response.data.response.headerName + "/" + response.data.response.id ,
                search: history.location.search
            })

        }).catch((e) => {
            console.log(e);
        })

    }

    const handleDelete = () => {
        if(window.confirm("Are you sure to remove?")) {
            HttpClient.delete("/api/v0/jcr/org/" + orgCmdProp?.currentOrg!.orgCode + "/header/" + deleteList.join(",")).then((response) => {
                setDeleteList([]);
                setFormKey(nanoid());
            }).catch((e) => {
                setDeleteList([]);
            })
        }
    }

    const handleDownloadList = () => {
        HttpClient.download(`Headers-${CurrentISODate()}.gz`,
            "/api/v0/jcr/orgs/" + orgCmdProp?.currentOrg!.orgCode + "/download/headers/" + deleteList.join(","));
        setDeleteList([]);
        setFormKey(nanoid());
    }


    if (params.hid && headerId !== params.hid) {
        setTimeout(() => {
            setHeaderId(params.hid);
        }, 100);
    }

    useEffect(() => {
        if(!(orgCmdProp && orgCmdProp.currentOrg !== null && orgCmdProp.orgDetail !== null)) return;
        if(headerId !== "") {
            HttpClient.get("/api/v0/jcr/org/" + orgCmdProp?.currentOrg!.orgCode + "/" + apiName + "/" +  headerId).then((response) => {
                setUpdateData(response.data.response);
            }).catch((e) => {
                console.log(e);
            })
        }


    },[headerId,orgCmdProp,dispatch])

    useEffect( () => {
        if(!(orgCmdProp && orgCmdProp.currentOrg !== null && orgCmdProp.orgDetail !== null)) return;
        setDataFetcher(new HeaderDataFetcher(orgCmdProp.currentOrg,() => {
                dispatch(viewResetAction());
            }
        ));
        setFormKey(nanoid());
    },[orgCmdProp,dispatch])


    const handleCloseUpdateDialog = () => {
        setUpdateData({});
        setHeaderId("");
        history.push({
            pathname: '/' + apiNames,
            search: history.location.search
        });
    }

    const handleAction = (tag:string, tagObject: any) => {
        if(tag === "DUPLICATE") {
            HttpClient.get("/api/v0/jcr/orgs/" + orgCmdProp?.currentOrg!.orgCode + "/clone/" + apiNames + "/" +  tagObject.id)
                .then((response) => {
                    let id = response.data.response;
                    history.push({
                        pathname: `${history.location.pathname}/${tagObject.viewName}/${id}`,
                        search: history.location.search
                    })
                })
        } else if(tag === "DOWNLOAD") {
            HttpClient.download(`Header-${tagObject.headerName}-${tagObject.id}.gz`,
                 "/api/v0/jcr/orgs/" + orgCmdProp?.currentOrg!.orgCode + "/download/" + apiNames + "/" +  tagObject.id);
        }
    }


    const newButton = <IconLinkButton tooltip={"Add New Header"} key="newHeaderButton" id="newHeaderButton" data-action="createNewHeader" variant={"contained"} onClick={handleOpenNewDialog}>
        <OutlinedIcon className={styles.Icon} >add_circle_outline</OutlinedIcon>
    </IconLinkButton>;

    const uploadButton = <IconLinkButton tooltip={"Upload File"} key="uploadHeaderButton" id="uploadHeaderwButton" data-action="uploadNewHeader" variant={"contained"} onClick={handleUploadDialog}>
        <OutlinedIcon className={styles.Icon} >cloud_upload</OutlinedIcon>
    </IconLinkButton>;

    const deleteButton = <ReverseSolidLinkSmallButton id="deleteHeaderButton" data-action="deleteHeaders" variant={"contained"} onClick={handleDelete}>
        <OutlinedIcon className={styles.Icon} >delete</OutlinedIcon>
        Remove ({deleteList.length})
    </ReverseSolidLinkSmallButton>;

    const downloadButton = <ReverseSolidLinkSmallButton id="downloadHeaderButton" data-action="downloadHeaders" variant={"contained"} onClick={handleDownloadList}>
        <OutlinedIcon className={styles.Icon} >download</OutlinedIcon>Download ({deleteList.length})
    </ReverseSolidLinkSmallButton>;

    return <React.Fragment>

        <div className={commonStyle.ContentContainer  + " " + commonStyle.ContentContainerOverflowX}>
            <PageSummary type={"headers"}/>
            {   newOpen &&
                <InputDialog
                    id={"header"}
                    title={"New Header"}
                    handleClose={handleCloseNewDialog}
                    handleSave={handleSaveDialog}
                    open={newOpen}
                    inserted={true}
                    fields={[
                        {id: "headerName", label: "Name", defaultValue: "", required: true , editable: true},
                    ]}
                    fixHeight={false}
                    contentText={null}/>
            }
            {headerId !== "" && updateData.id &&
                <InputDialog
                    id={"header"}
                    title={"Rename Header"}
                    handleClose={handleCloseUpdateDialog}
                    handleSave={handleUpdateDialog}
                    open={true}
                    inserted={false}
                    fixHeight={false}
                    fields={[
                        {id: "headerName", label: "Name", defaultValue: updateData.headerName, required: true , editable: true},
                    ]}
                    contentText={null}/>
            }

            <StyledTable
                        key={formKey}
                        handleDeleteLists={(ids) => setDeleteList(ids)}
                        handleAction={handleAction}
                        hasCheckBox={true}
                        dataFetcher={dataFetcher}
                        rowsPerPage={20}

                        title={"Headers"}
                        actionComponents={[uploadButton,newButton]}
                        deleteButton={deleteButton}
                        downloadButton={downloadButton}

                        page={parseInt((query.get("page") === null ? "0" : query.get("page")!))}
                        rowsPerPageOptions={[5,10,20,40,60,{label: "All" , value: -1}]}/>
            <input key={`upload_${formKey}`} type='file' id='upload-content'
                   accept=".gzip,.gz"
                   onChange={() => doUploadFile()}
                   ref={inputFile} style={{display: 'none'}}/>
        </div>

    </React.Fragment>
}